import React, {Component} from 'react';
import { Badge } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import APNotificationBellStyle from './styles/APNotificationBell.style';
import { ReactComponent as NotificationBellIcon} from './assets/notificationBell.svg';
import { NavLink as RouterLink } from 'react-router-dom';

interface APNotificationBellProps extends WithStyles<typeof APNotificationBellStyle> {
    className?: string,
    unreadCount?: number
}

class APNotificationBell extends Component<APNotificationBellProps, {}> {
    render() {

        const { classes, unreadCount } = this.props;

        return (
            <RouterLink to="/notifications">
                <div className={classes.root}>
                    <Badge className={classes.badgeIcon}
                           badgeContent={unreadCount}
                           max={9}
                           color="primary">
                        <NotificationBellIcon className={classes.notificationBellIcon} />
                    </Badge>
                </div>
            </RouterLink>
        );
    }
}

export default withStyles(APNotificationBellStyle)(APNotificationBell);